import { Clock, MapPin, CreditCard } from "lucide-react";
import { HOURS, PAYMENTS } from "../lib/prestations";
import { ZONES } from "../lib/data";

export default function InfoStrip() {
  return (
    <div data-testid="info-strip" className="grid md:grid-cols-3 gap-6">
      <div className="card-soft p-6 hover:translate-y-0">
        <span className="h-11 w-11 rounded-xl bg-brand/10 flex items-center justify-center">
          <Clock className="h-5 w-5 text-brand" />
        </span>
        <h3 className="font-display font-bold text-ink text-lg mt-4">Horaires</h3>
        <p className="text-ink-soft mt-1">{HOURS}</p>
        <p className="text-brand-green font-semibold mt-1">Toujours ouvert</p>
      </div>
      <div className="card-soft p-6 hover:translate-y-0">
        <span className="h-11 w-11 rounded-xl bg-brand/10 flex items-center justify-center">
          <MapPin className="h-5 w-5 text-brand" />
        </span>
        <h3 className="font-display font-bold text-ink text-lg mt-4">Zones d&apos;intervention</h3>
        <div className="flex flex-wrap gap-2 mt-3">
          {ZONES.map((z) => (
            <span key={z} className="chip">{z}</span>
          ))}
        </div>
      </div>
      <div className="card-soft p-6 hover:translate-y-0">
        <span className="h-11 w-11 rounded-xl bg-brand/10 flex items-center justify-center">
          <CreditCard className="h-5 w-5 text-brand" />
        </span>
        <h3 className="font-display font-bold text-ink text-lg mt-4">Moyens de paiement</h3>
        <div className="flex flex-wrap gap-2 mt-3">
          {PAYMENTS.map((p) => (
            <span key={p} className="chip">{p}</span>
          ))}
        </div>
      </div>
    </div>
  );
}
